import { SVGProps } from 'react';
import { ReactComponent } from 'icons/half-filled-circle.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const HalfFilledCircle = (props: Props) => (
  // @ts-ignore
  <ReactComponent {...props} alt="half filled circle" />
);
